import { Component, OnInit } from '@angular/core';
import {
	CustomFormAccessor,
	FormConfig,
} from 'src/shared/form-models/form-cva.component';
import { NgControl, FormBuilder } from '@angular/forms';
import { OptionalJobFieldsToShow } from '../optional-fields.models';

const railroadOptionalJobFieldsFormConfig: FormConfig<OptionalJobFieldsToShow> =
	{
		showWorkOrderNumber: [''],
		showProjectNumber: [''],
		showProjectManagerName: [''],
		showTermsAndConditions: [''],
		showIsSupervisorJob: [''],
		showNetworkOrServiceOrder: [''],
		showIsThirdPartyJob: [''],
		showAgreementNumber: [''],
		showUpFolderNumber: [''],
		showNsActivityNumber: [''],
		showProtection: [''],
		showReferenceNumber: [''],
		showTrackID: [''],
		showOrderNumber: [''],
		showRequiresJobSetups: [''],
	};

@Component({
	selector: 'rpfsa-optional-job-fields-to-show',
	templateUrl: './optional-job-fields-to-show.component.html',
})
export class OptionalJobFieldsToShowComponent
	extends CustomFormAccessor<OptionalJobFieldsToShow>
	implements OnInit
{
	constructor(public ngControl: NgControl, public fb: FormBuilder) {
		super(ngControl, fb, railroadOptionalJobFieldsFormConfig);
	}
}
